<!-- 证券从业考试 (教师端)-->
<template>
  <div class="el-TCoachExamDetailed">
    <el-row class="content_block mb30">
      <TitleInfo title="从业考证" :titleImg="kaoshi"></TitleInfo>

      <el-row class="pt20 pl20 coachExamList_list">
        <el-row>
          <el-input v-model="studentOrName" clearable style="width: 200px;" prefix-icon="el-icon-search" placeholder="请输入学号或姓名"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
        </el-row>
        <el-table
          :data="myAppsList"
          style="width: 100%">
          <el-table-column
            prop="studentName" header-align="center" align="center" label="姓名" width="180">
          </el-table-column>
          <el-table-column
            prop="studentSn" header-align="center" align="center" label="学号">
          </el-table-column>
          <el-table-column header-align="center" align="center" label="试卷总分数">
            <template v-slot="scope">
              {{scope.row.questionSettingTotalScore || '0' | toDecimalx(1) }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="学生得分">
            <template v-slot="scope">
              {{scope.row.questionLogSummaryStudentTotalScore || '0' | toDecimalx(1) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="finishTime" header-align="center" align="center" label="用时">
          </el-table-column>
          <el-table-column
            prop="studentRank" header-align="center" align="center" label="排名">
          </el-table-column>
        </el-table>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[15, 20, 40,200]"
        :page-size="limit"
        background
        class="m20 t_r"
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "CoachExamList",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      generalQuestionSettingId:this.$route.query.generalQuestionSettingId,
      kaoshi:require("../../images/coach/kaoshi@2x.png"),
      js2:require("../../images/course/js2.png"),
      myAppsList:[],
      total: 0,
      limit:15,
      page:1,
      studentOrName:"",
      value:"",
      courseInfoName:this.$route.query.courseInfoName,
      timeIn:null
    };
  },
  created() {
    this.getInfo();
    //this.addSystem();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        studentOrName:this.studentOrName,
        studentSnOrName:this.studentOrName,
        questionSettingId: this.generalQuestionSettingId,
        questionLogSummaryFromType: "FROM_SYSTEM",
        questionLogSummaryStatus: 1,
        questionSettingType: "EXAM",
        orgId:this.$ls.get(this.$getKeyInfo("userInfo")).orgId || {}
      }
      this.$post("/api/questionLogSummary/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExam(item){ //考试考试
      this.$router.push({name:'CoachExam',query:{generalQuestionSettingId:item.generalQuestionSettingId}});
    },
    resultDetails(item){ //详情
      this.$router.push({name:'CoachExamDetails',query:{generalQuestionSettingId:item.generalQuestionSettingId}});
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:this.courseInfoName,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-TCoachExamDetailed{
    padding: 20px 20px 0;
    .coachExamList_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: calc(33.3% - 65px);
        padding: 20px;
        margin: 0 20px 20px 0;
        border: 1px solid #E1E1E1;
        font-size: 14px;
      }
      .but_icon{
        width: 33%;height: 55px;float: left;text-align: center;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 200px;
      height: 148px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/TCoachExamDetailed.vue